import React, { useState } from 'react';
import { URL } from '../../config'
import ButtonRounded from './buttonRounded';

const ImageCarouselItem = ({ imageAttr, size }) => {
  return <img
    className={`App-image-carousel-item${imageAttr.file.height > imageAttr.file.width ? ' vertical' : ''}`}
    src={size ? URL + imageAttr.formats[size].url : URL + imageAttr.file.url}
    key={imageAttr.id}
    width={size ? imageAttr.formats[size].width : imageAttr.file.width}
    height={size ? imageAttr.formats[size].height : imageAttr.file.height}
    alt={imageAttr.description}
  />
}

const ImageCarousel = ({ images }) => {
  const [currImg, setCurrImg] = useState(0)
  const [fullscreen, setFullscreen] = useState(false)

  function toggleCarousel() {
    setFullscreen(curr => !curr)
  }

  function next(e) {
    e.stopPropagation()
    setCurrImg(n => (n+1 < images.length) ? n+1 : 0)
  }

  function prev(e) {
    e.stopPropagation()
    setCurrImg(n => (n-1 >= 0) ? n-1 : images.length-1)
  }

  return (
    <div className="App-image-carousel" onClick={toggleCarousel}>
      { images.length ? <ImageCarouselItem imageAttr={images[0]} /> : "" }
      { fullscreen && images.length &&
        <div className="App-image-carousel-fullscreen">
          { images.length > 1 && <ButtonRounded label="&larr;" action={prev} /> }
          <div className="App-image-carousel-fullscreen-container">
            <div style={{textAlign:'center'}}>
              <ImageCarouselItem imageAttr={images[currImg]} />
              <p className="App-image-carousel-description">{images[currImg].description}</p>
            </div>
          </div>
          { images.length > 1 && <ButtonRounded label="&rarr;" action={next} /> }
        </div>
      }
    </div>
  )
}

export default ImageCarousel;